<template>
    <div>
        <tool-button :icon="icon" />
        <dropdown-menu :actions="actions" />
    </div>
</template>

<script>
import DropdownMenu from './DropdownMenu.vue';
import ToolButton from './ToolButton.vue';

export default {
    components: {
        ToolButton,
        DropdownMenu,
    },
    name: 'ToolButtonContext',
    props: {
        actions: Array,
        icon: {
            type: String,
            default: 'dots-vertical',
        },
    },
};
</script>

<style scoped>

</style>
